import React, { FC } from 'react';

import styled from 'styled-components';

import { useTranslation } from 'react-i18next';

import { ESpacing } from '@aquariuxfintech/aqx-trader-react-ui/foundation';
import { showBasicSnackBar } from '@aquariuxfintech/aqx-trader-react-ui/snack-bar';

import { EMainProductCodeType } from '@aqx-core/common/api/config';
import { useCompanyProfile } from '@aqx-core/common/services/company';
import { useSignUpDemo } from '@aqx-core/common/services/sign-up-demo';
import { EUISnackBarMessageType } from '@aqx-core/common/services/snackbar';
import { kNumberFormatter } from '@aqx-core/common/utils/price';

import DemoCompletionDetailHeader from '../../../shared/demo-completion-step/detail-header';
import DemoCompletionDetailItem from '../../../shared/demo-completion-step/detail-item';
import { StyledDemoCompletionDetailsContainer } from '../../../shared/demo-completion-step/styled';

const SignUpDemoAccountDetails: FC = () => {
  const { t } = useTranslation();
  const { details } = useSignUpDemo();

  const { login, password, investorPassword, name, leverage, deposit, currency } = details || {};

  const leverageText = `1:${leverage}`;
  const depositText = `${kNumberFormatter(deposit)} ${currency}`;

  const onCopy = () => {
    let textToCopy = '';

    if (login) {
      textToCopy += `Login: ${login}\n`;
    }
    if (password) {
      textToCopy += `Password: ${password}\n`;
    }
    if (investorPassword) {
      textToCopy += `View Only Password: ${investorPassword}\n`;
    }
    if (name) {
      textToCopy += `Name: ${name}\n`;
    }
    if (leverage) {
      textToCopy += `Leverage: 1 : ${leverage}\n`;
    }
    if (deposit || currency) {
      textToCopy += `Deposit: ${depositText}\n`;
    }

    navigator.clipboard.writeText(textToCopy).then(() =>
      showBasicSnackBar({
        messageType: EUISnackBarMessageType.SUCCESS,
        message: t('Copied to clipboard.'),
        delay: 1500
      })
    );
  };

  const isCreatingCentroidDemoAccount = useCompanyProfile()?.firstDemoTenantProduct === EMainProductCodeType.CENTROID;

  return (
    <StyledContainer>
      <DemoCompletionDetailHeader title={t('Demo account details')} onCopy={onCopy} />

      <StyledDemoCompletionDetailsContainer>
        <DemoCompletionDetailItem label={t('Login')} value={login} />

        <DemoCompletionDetailItem label={t('Password')} value={password} />

        <DemoCompletionDetailItem label={t('View only password')} value={investorPassword} />

        <DemoCompletionDetailItem label={t('Name')} value={name} />

        {isCreatingCentroidDemoAccount ? null : <DemoCompletionDetailItem label={t('Leverage')} value={leverageText} />}

        <DemoCompletionDetailItem label={t('Deposit')} value={depositText} />
      </StyledDemoCompletionDetailsContainer>
    </StyledContainer>
  );
};

export default SignUpDemoAccountDetails;

const StyledContainer = styled.div`
  margin-top: ${ESpacing.XXL}px;
`;
